import { useSiteSettings } from './useSiteSettings';

/**
 * Returns a formatter function that formats a number with the configured currency symbol.
 * Usage: const { format } = useCurrency(); format(12.5) => "CHF 12.50"
 */
export const useCurrency = () => {
  const { get, loading } = useSiteSettings();
  const symbol = get('currency_symbol', 'CHF');
  const currency = get('currency', 'CHF');

  const format = (amount: number): string => {
    // For symbols that go after the number (e.g. kr, zł, Kč)
    const afterSymbols = ['kr', 'zł', 'Kč'];
    if (afterSymbols.includes(symbol)) {
      return `${amount.toFixed(2)} ${symbol}`;
    }
    return `${symbol} ${amount.toFixed(2)}`;
  };

  const formatShort = (amount: number): string => {
    const afterSymbols = ['kr', 'zł', 'Kč'];
    if (afterSymbols.includes(symbol)) {
      return `${amount.toFixed(2)} ${symbol}`;
    }
    return `${symbol}${amount.toFixed(2)}`;
  };

  return { format, formatShort, symbol, currency, loading };
};
